import { APIUrls } from "../../Constants/ApiUrls";
// import { IAlarm } from "../../Models/IAlarm"; //Fix Warning Complaint Code:071225
import { AjaxService, IAPIRequest, IAPIResponse } from "../AjaxService";

const AlarmsController = {
  GetAlarms: async (callback?: (response: IAPIResponse) => void) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = APIUrls.ALARMS.ALARMS_URL;
    request.allowApiCache = true;
    let response = await AjaxService.APICall(request, callback);
    return response;
  },
  GetNewAlarms: async (callback?: (response: IAPIResponse) => void) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = APIUrls.ALARMS.NEW_ALARMS_URL;
    let response = await AjaxService.APICall(request, callback);
    return response;
  },
  ManageAlarms: async (
    alarmId: string,
    refertReason: string,
    callback?: (response: IAPIResponse) => void
  ) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = APIUrls.ALARMS.ALARMS_BY_ID.replace(":alarmId", alarmId);
    request.method = "PUT";
    request.payload = { reason: refertReason };
    let response = await AjaxService.APICall(request, callback);
    return response;
  },
  GetPaginatedAlarms: async (
    page: number,
    perPage: number,
    callback?: (response: IAPIResponse) => void
  ) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = `${APIUrls.ALARMS.ALARMS_URL}/${page}/${perPage}`;
    request.allowApiCache = true;
    let response = await AjaxService.APICall(request, callback);
    return response;
  },
};

export default AlarmsController;
